import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import sensorService from './sensorService'

const initialState = {
    devices: [],
    currentDevice: null,
    sensorData: [],
    isError: false,
    isSuccess: false,
    // isLoading: false,
    isUserDevicesLoading: true,
    isSensorDataLoading: true,
    isConnectionLoading: false,
    message: "",
    connectionSuccessMessage: "",
    temperature: "",
    humidity: "",
    soil_moisture: "",
    light_intensity: "",
    water_level: ""
};

// Connect device with the logged-in user
export const connect = createAsyncThunk('device-data/connect', async (data, thunkAPI) => {
    try {
        const token = thunkAPI.getState().auth.user.token;
        return await sensorService.connect(data, token);
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
});

export const getSensorData = createAsyncThunk('device-data/get-sensor-data', async (data, thunkAPI) => {
    try {
        const token = thunkAPI.getState().auth.user.token;
        console.log(data.timeframe);
        switch (data.timeframe) {
            case "Last 12h":
                data.timeframe = "12h";
                break;
            case "Last 24h":
                data.timeframe = "24h";
            break;
            case "Week":
                data.timeframe = "w";
            break;
            case "Month":
                data.timeframe = "m";
            break;
            default:
                break;
        }
        return await sensorService.getSensorData(data, token);
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
});

export const getUserDevices = createAsyncThunk('device-data/user-devices', async (data, thunkAPI) => {
    try {
        const token = thunkAPI.getState().auth.user.token;
        return await sensorService.getUserDevices(data, token);
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
});

export const changeCurrentDevice = createAsyncThunk('device-data/change-current-device', async (data, thunkAPI) => {
    return data;
});

export const addNewSensorData = createAsyncThunk('device-data/add-new-sensor-data', async (data, thunkAPI) => {
    return data;
});

export const updateLiveReadings = createAsyncThunk('device-data/update-live-readings', async (data, thunkAPI) => {
    return data;
});

export const resetStatus = createAsyncThunk('device-data/reset-status', async (data, thunkAPI) => {
    return data;
});

export const resetOnCurrentDeviceChange = createAsyncThunk('device-data/reset-on-device-change', async (data, thunkAPI) => {
    return data;
});

export const sensorSlice = createSlice({
    name: 'sensor',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(connect.pending, (state) => {
                state.isConnectionLoading = true;
                state.isError = false;
                state.isSuccess = false;
            })
            .addCase(connect.fulfilled, (state, action) => {
                const deviceData = action.payload.data;
                console.log(JSON.stringify(deviceData));
                const deviceId = deviceData._id;
                const name = deviceData.name;
                const updatedDevices = [ ...state.devices ];

                if(updatedDevices) {
                    const alreadyAdded = updatedDevices.filter(device => device._id === deviceId);
                    if(alreadyAdded && alreadyAdded.length>0) {
                        console.log(`Device ${deviceId} is already in your connected devices list.`);
                        // update it?
                    }
                    else {
                        state.devices = [ ...state.devices, { ...deviceData } ];
                    }
                }
                else {
                    console.log(`Device list empty, adding first device: ${deviceId}`);
                    state.devices = [ ...state.devices, deviceId ];
                }

                state.currentDevice = { id: deviceId, name: name };
                state.isError = false;
                state.isSuccess = true;
                state.isConnectionLoading = false;
                state.message = '';
                state.connectionSuccessMessage = `Device ${deviceId} successfully connected.`;
                console.log(`Device ${deviceId} successfully connected.`);
            })
            .addCase(connect.rejected, (state, action) => {
                // const data = action.payload.data;
                // console.log(JSON.stringify(data));
                console.log("Failed connecting new device.");
                console.log(action.payload);
                state.isConnectionLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = `Failed connecting new device: ${action.payload}`;
            })
            .addCase(getUserDevices.pending, (state) => {
                state.isUserDevicesLoading = true;
                state.isError = false;
                state.isSuccess = false;
            })
            .addCase(getUserDevices.fulfilled, (state, action) => {
                const userDevices = action.payload.data;
                // console.log(JSON.stringify(userDevices));

                state.devices = [ ...userDevices ];
                const currentDevice = userDevices.length > 0 ? { id: userDevices[0]._id, name: userDevices[0].name } : null; //NE MENJAJ AKO VEC POSTOJI
                const favoriteDevice = JSON.parse(localStorage.getItem('currentDevice'))
                if(favoriteDevice && userDevices.filter(device => device._id === favoriteDevice.id).length == 1) {
                    state.currentDevice = favoriteDevice
                }
                else {
                    state.currentDevice = userDevices[0] ? currentDevice : undefined;
                }
                state.isError = false;
                state.isSuccess = true;
                state.isUserDevicesLoading = false;
                state.message = '';
                console.log(`Successfully loaded user's devices.`);
            })
            .addCase(getUserDevices.rejected, (state, action) => {
                console.log("Failed getting user's devices.");
                state.isUserDevicesLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = `Failed getting user's devices from the server: ${action.payload}`;
            })
            .addCase(getSensorData.pending, (state) => {
                state.isSensorDataLoading = true;
            })
            .addCase(getSensorData.fulfilled, (state, action) => {
                state.sensorData = action.payload.data;
                state.isError = false;
                state.isSuccess = true;
                state.isSensorDataLoading = false;
                state.message = '';
                console.log(`Successfully loaded ${action.payload.data.length} device's sensor readings.`);
            })
            .addCase(getSensorData.rejected, (state, action) => {
                console.log("Failed getting device's sensor readings from the server.");
                state.isSensorDataLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = `Failed getting device's sensor readings from the server: ${action.payload}`;
            })
            .addCase(changeCurrentDevice.fulfilled, (state, action) => {
                const currentDevice = action.payload;
                state.currentDevice = { ...currentDevice };
                localStorage.removeItem('currentDevice');
                localStorage.setItem('currentDevice', JSON.stringify({ ...currentDevice }));
                console.log(`Successfully set current device to ${currentDevice.name}.`);
            })
            .addCase(addNewSensorData.fulfilled, (state, action) => {
                const newSensorData = action.payload;
                state.sensorData = [ ...state.sensorData, newSensorData ];
                console.log(`Successfully added new sensor data to the sensorData array.`);
            })
            .addCase(resetStatus.fulfilled, (state, action) => {
                state.isError = false;
                state.isSuccess = false;
            })
            .addCase(updateLiveReadings.fulfilled, (state, action) => {
                const data = action.payload;
                state.temperature = data.temperature;
                state.humidity = data.humidity;
                state.soil_moisture = data.soil_moisture;
                state.light_intensity = data.light_intensity;
                state.water_level = data.water_level;
                console.log(`Successfully updated ${data.id} live readings.`);
            })
            .addCase(resetOnCurrentDeviceChange.fulfilled, (state, action) => {
                state.currentDevice =  null;
                state.sensorData = [];
                state.temperature = "";
                state.humidity = "";
                state.soil_moisture = "";
                state.light_intensity = "";
                state.water_level = "";
            })
    }
})

export const { reset } = sensorSlice.actions;
export default sensorSlice.reducer;